import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Conversation} from '../../../models/chat';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/enviroment';

export interface TranscriptMessage {
  content: string;
  datePending: string;
  dateSent?: string;
  type: 'agent' | 'user';
}

export interface PagedHistory {
  items: Conversation[];
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class ConversationHistoryService {
  private baseUrl = environment.mindxbkUrl;

  constructor(private http: HttpClient) {
  }

  /**
   * Trae la página de conversaciones finalizadas para un agente,
   * usando skip & limit como query params, y poniendo el Bearer token.
   */
  getFinishedConversations(
    agentId: string,
    skip: number,
    limit: number
  ): Observable<Conversation[]> {
    const url = `${this.baseUrl}/CustomerConversation/Conversation/Conversations/${agentId}/Finish`;
    const params = new HttpParams()
      .set('skip', skip.toString())
      .set('limit', limit.toString());

    const token = localStorage.getItem('auth_req') || '';
    const headers = new HttpHeaders({
      Accept: '*/*',
      Authorization: `Bearer ${token}`
    });

    return this.http.get<Conversation[]>(url, {headers, params});
  }

  getTranscript(conversationId: string): Observable<TranscriptMessage[]> {
    const url = `${this.baseUrl}/CustomerMessage/Message/${conversationId}`;
    const token = localStorage.getItem('auth_req') || '';
    const headers = new HttpHeaders({
      Accept: '*/*',
      Authorization: `Bearer ${token}`
    });

    return this.http
      .get<Array<{
        type: string;
        content: string;
        contentTranslated: string | null;
        datePending?: string;
      }>>(url, { headers })
      .pipe(
        map(raw => {
          // Mapeo inicial
          const mapped: TranscriptMessage[] = raw.map(msg => {
            const t: 'agent' | 'user' = msg.type === 'agent' ? 'agent' : 'user';
            return {
              content: msg.contentTranslated ?? msg.content,
              datePending: msg.datePending ?? '',
              type: t
            };
          });

          // Si todos tienen dateSent válido, los ordeno; si no, devuelvo el orden original
          const allHaveDate = mapped.every(m => m.datePending);
          if (allHaveDate) {
            return mapped.sort((a, b) =>
              new Date(a.datePending).getTime() - new Date(b.datePending).getTime()
            );
          } else {
            return mapped;
          }
        })
      );
  }
}
